import React, { useState } from 'react';
import { Check, MapPin, Phone, Star } from 'lucide-react';
import { Button } from './Button';
import { Input } from './Input';
import { Textarea } from './Textarea';
export function Consultation() {
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitted(true);
  }
  return <section id="consultation" className="bg-[#173d36] py-20 text-white sm:py-28" data-id="element-10">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-24" data-id="element-11">
        <div data-id="element-12">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8de0e5]" data-id="element-13">
            Begin here
          </p>
          <h2 className="mt-5 text-4xl font-medium leading-tight tracking-[-0.045em] sm:text-5xl" data-id="element-14">
            Tell us what you are dreaming about.
          </h2>
          <p className="mt-6 max-w-md leading-7 text-[#c6d9d1]" data-id="element-15">
            A simple first step toward a pool that is designed around you. Share
            what you know—we’ll take it from there.
          </p>
          <div className="mt-10 space-y-4 text-sm text-[#d8e7e1]" data-id="element-16">
            <a className="flex items-center gap-3 hover:text-[#8de0e5]" href="tel:+16025656313" data-id="element-17">
              <Phone size={17} aria-hidden="true" data-id="element-18" />
              (602) 565-6313
            </a>
            <p className="flex items-start gap-3" data-id="element-19">
              <MapPin size={17} className="mt-0.5 shrink-0" aria-hidden="true" data-id="element-20" />
              3242 W Orangewood Ave
              <br data-id="element-21" />
              Phoenix, AZ 85051
            </p>
            <p className="flex items-center gap-3" data-id="element-22">
              <Star size={17} className="fill-[#8de0e5] text-[#8de0e5]" aria-hidden="true" data-id="element-23" />
              4.6 Google rating
            </p>
          </div>
        </div>
        <div className="rounded-[1.5rem] bg-[#f4f0e7] p-6 text-[#173d36] sm:p-9" data-id="element-24">
          {submitted ? <div className="flex min-h-[340px] flex-col justify-center" data-id="element-25">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#b9e5df] text-[#173d36]" data-id="element-26">
                <Check size={25} aria-hidden="true" data-id="element-27" />
              </span>
              <h3 className="mt-6 text-3xl font-medium tracking-tight" data-id="element-28">
                Thank you—we’ve got it.
              </h3>
              <p className="mt-3 max-w-md leading-7 text-[#5d675f]" role="status" data-id="element-29">
                Your project details have been received. Our team will be in
                touch to continue the conversation.
              </p>
              <Button onClick={() => setSubmitted(false)} variant="outline" className="mt-8 w-fit rounded-full border-[#83948c] bg-transparent text-[#173d36] hover:bg-[#e4dfd3]" data-id="element-30">
                Submit another inquiry
              </Button>
            </div> : <form onSubmit={handleSubmit} data-id="element-31">
              <h3 className="text-2xl font-medium tracking-tight" data-id="element-32">
                Your pool project
              </h3>
              <p className="mt-2 text-sm text-[#5d675f]" data-id="element-33">
                A few details are all we need to get started.
              </p>
              <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-34">
                <label className="text-sm font-medium" data-id="element-35">
                  Name
                  <Input required name="name" className="mt-2 h-11 border-[#b3b5a9] bg-white" data-id="element-36" />
                </label>
                <label className="text-sm font-medium" data-id="element-37">
                  Phone
                  <Input required name="phone" type="tel" className="mt-2 h-11 border-[#b3b5a9] bg-white" data-id="element-38" />
                </label>
                <label className="text-sm font-medium sm:col-span-2" data-id="element-39">
                  Email
                  <Input required name="email" type="email" className="mt-2 h-11 border-[#b3b5a9] bg-white" data-id="element-40" />
                </label>
                <label className="text-sm font-medium sm:col-span-2" data-id="element-41">
                  What are you considering?
                  <Textarea required name="message" rows={4} placeholder="New pool, natural conversion, remodel..." className="mt-2 resize-none border-[#b3b5a9] bg-white" data-id="element-42" />
                </label>
              </div>
              <Button type="submit" size="lg" className="mt-7 h-12 w-full rounded-full bg-[#173d36] text-white hover:bg-[#28564e]" data-id="element-43">
                Send project inquiry
              </Button>
            </form>}
        </div>
      </div>
    </section>;
}